import type { RequestPath } from "./api-client"
import { isPWA } from "./device"

// Helper function to add display_platform parameter to any path
export function addDisplayPlatform(path: RequestPath, additionalParams?: string): string {
  const displayPlatformParam = `display_platform=${isPWA() ? '2' : '0'}`
  
  if (additionalParams) {
    return `${path}?${additionalParams}&${displayPlatformParam}`
  }
  
  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}${displayPlatformParam}`
}
